import { motion } from "framer-motion";
import { IMG } from "@/lib/assets";

const EASE = [0.16, 1, 0.3, 1];

export const Manifesto = () => {
  return (
    <section data-testid="manifesto-section" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, ease: EASE }}
          className="font-display italic font-medium text-3xl md:text-5xl lg:text-6xl text-ink leading-[1.2]"
        >
          The Upgrade Your Health meditation allows your body to shift into rest and relaxation in minutes.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1.1, ease: EASE }}
          className="mt-14 md:mt-20 w-full h-[46vh] md:h-[68vh] overflow-hidden rounded-[1.5rem] md:rounded-[2rem]"
        >
          <img src={IMG.manifesto} alt="Walking through the ruins" className="h-full w-full object-cover object-[center_35%]" />
        </motion.div>
      </div>
    </section>
  );
};

export default Manifesto;
